import Location from 'app-location'
import * as Yup from 'yup'

export const InstitutionEndpoint = new Location('/v1/institutions/:institutionId', {
  institutionId: Yup.number(),
})

export const InstitutionsEndpoint = new Location('/v1/institutions?per=:pageSize', {
  pageSize: Yup.number(),
})

export const InstitutionsV2Endpoint = new Location('/v2/public/institutions')
